interface SortObjectsClosureOptions<T, K extends keyof T> {
  propertyName: K;
  order: 'ascending' | 'descending';
  map?: (value: T[K]) => any;
}

export function sortObjectsClosure<T, K extends keyof T>(options: SortObjectsClosureOptions<T, K>) {
  return (a: T, b: T) => {
    const mapFunction = options.map ?? (value => value);
    const aValue = mapFunction(a[options.propertyName]);
    const bValue = mapFunction(b[options.propertyName]);

    if (aValue === bValue) {
      return 0;
    }

    if (options.order === 'descending') {
      return aValue > bValue ? -1 : 1;
    }

    return aValue > bValue ? 1 : -1;
  };
}
